module.exports = __webpack_public_path__ + "media/images/logo-9055b1f0c4f198e133eef179d104dfe8.png";